//Async dynamic import required for Module Federation shared modules.
// Webpack must resolve shared singletons (react, react-dom, react-router-dom)
// BEFORE any application code runs.  The real mount lives in bootstrap.js.
import("./bootstrap");
n